/**
 * AnalyticsHelper — Disabled: no external analytics for this installation.
 * All methods are no-ops to prevent any data from being sent to Amplitude or other providers.
 * @class AnalyticsHelper
 */
export class AnalyticsHelper {
  constructor() {
    this.analyticsToken = null;
    this.analytics = null;
    this.user = {};
  }

  async init() {
    this.analytics = null;
  }

  identify(user) {
    this.user = user || {};
  }

  track(eventName, properties = {}) {
    this.lastEvent = { eventName, properties };
  }

  page(pageName, properties = {}) {
    this.lastPage = { pageName, properties };
  }
}

export default new AnalyticsHelper();
